// extracted by mini-css-extract-plugin
module.exports =  {"root":"PaneActions-module__root--wePp1","button":"PaneActions-module__button--aktEJ","active":"PaneActions-module__active--tEpw2"};